module.exports = __webpack_public_path__ + "img/065-eritrea.d049eeaa.svg";